import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {AndroidIcon, IphoneIcon, GameIcon, CustomSoftIcon, SoftwareProIcon, SoftwareMainIcon} from "../../../app-constants";
import { Link } from 'gatsby'; // Import Gatsby's Link component
import HtmlParser from 'react-html-parser';

const StackItem = [
    {
        icon: AndroidIcon,
        title: 'Android app development',
        description: (
            <>
                Improve your{' '}
                <Link to="/android-app-development" rel="noopener" aria-label="TekRevol">
                    Android app development
                </Link> {' '}
                experience with TekRevol, making the most of the world's most extensively used platform with native apps. Our dynamic tech stack of Java or Kotlin blows life into your app concepts with accuracy and invention.
            </>
        ),
    },
    {
        icon: IphoneIcon,
        title: 'Iphone app development',
        description: 'Raise your iOS experience with TekRevol\'s iPhone App Development, providing sophisticated, impeccably functional native apps. We methodically contemplate every feature, warranting your app fluently aligns with Apple\'s design philosophies and guiding principle.',
    },
    {
        icon: GameIcon,
        title: 'Game app development',
        description: (
            <>
                Dive into the profitable gaming industry with TekRevol's{' '}
                <Link to="/game-development" rel="noopener" aria-label="TekRevol">
                    mobile game development,
                </Link> {' '}
                delivering highly enveloping and monetization-ready games for your business. Gifted in numerous genres such as shooting, arcade, RPG, and strategy, we can deliver any game idea you visualize to life.
            </>
        ),
    },
    {
        icon: CustomSoftIcon,
        title: 'Custom Software Development',
        description: (
            <>
                Custom software solutions intended to match your exclusive business requirements, guaranteeing ideal functionality and effectiveness. TekRevol fuels your{' '}
                <Link to="/custom-software-development" rel="noopener" aria-label="TekRevol">
                    custom software development
                </Link> {' '}
                projects with extensive knowledge and plentiful resources.
            </>
        ),
    },
    {
        icon: SoftwareProIcon,
        title: 'Software Product Development',
        description: 'Pioneering, scalable software product development, propelling market success via creativity and progressive technology. TekRevol focuses on developing strong SaaS, Mobile, and desktop software products with unparalleled user experience.',
    },
    {
        icon: SoftwareMainIcon,
        title: 'Software Support and Maintenance',
        description: 'Consistent support and upkeep services, guaranteeing effortless operations and endurance of your software products. We assure flawless functionality and bearing through incessant performance monitoring, optimization, new feature application, and issue addressing.',
    },

];

function Improvise(props) {
    return (
        <div className="improvise_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                <Col xs={12} md={12} lg={12} xl={10} xxl={4} className="m-xl-auto m-xxl-0">
                        <h2>Elevate Your Businesses With App & Software Development Services in New Jersey</h2>
                        <p className="impro_para">Experience transformation with TekRevol’s custom application and software development services in NJ, crafted to make your digital presence better. Propel your business with cutting-edge technology and resourcefulness, creating unparalleled success and market effectiveness. We serve as your all-encompassing development partner, devoted to driving your business to extraordinary heights.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
                        <div className="stack_box">
                            {StackItem.map((item, index) => (
                                <div className="stack_item" key={index}>
                                    <div className="stack_title">
                                        {item.icon}
                                        <h5>{item.title}</h5>
                                    </div>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Improvise;